import { AccountAlertIcon } from './AccountAlertIcon';

/**
 * author: Austin Andrews
 * id 3D869F3A-8C3E-4ECB-829E-7785230FA680
 * name account-alert
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-alert.svg
 * tags
 * - Account / User 
 * - Alert / Error 
 */
export const AccountWarningIcon = AccountAlertIcon;
export default AccountWarningIcon